module.exports = __webpack_public_path__ + "static/media/hero-image-small.59752bfd.jpg";